import {h, Fragment} from "preact"
import { useFacets, useAppState } from "@nosto/preact";
import { useState } from "preact/hooks";
import Facet from "./Facet";
import RangeFacet from "./RangeFacet";
import Icon from "./elements/Icon";
import SelectedFilters from "./SelectedFilters";
import SidebarAside from "./SidebarAside";

function ToggleSidebarButton({ className }) {
  return (
    <label
      className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
      for="toggle-desktop-sidebar"
    >
      <Icon name="close" />
    </label>
  );
}

export default function SideBar() {
  const { loading, facets } = useFacets();
  const { query, response, pageType } = useAppState();
  const [opened, setOpened] = useState(null);
  let isMobile = window.innerWidth < 769;

  return facets?.length > 0 ? (
    <>
      <div
        class="ns-cat-sidebar-wrapper ns-d-none ns-d-md-flex ns-align-items-center"
        style={loading ? "opacity: 0.3;" : ""}
      >
        <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
          <div class="ns-sidebar-menu">
            <ul class="ns-list-unstyled ns-p-0 ns-m-0 ns-d-flex ns-align-items-center">
              {facets?.map((facet) => {
                switch (facet.type) {
                  case "terms":
                    return (
                      <Facet
                        facet={facet}
                        opened={opened}
                        setOpened={setOpened}
                      />
                    );
                  case "stats":
                    return (
                      <RangeFacet
                        facet={facet}
                        opened={opened}
                        setOpened={setOpened}
                      />
                    );
                  default:
                    return null;
                }
              })}
              <li>
                <input
                  type="checkbox"
                  id="toggle-desktop-sidebar"
                  class="ns-facet-sidebar-toggle ns-d-none"
                />
                <label
                  for="toggle-desktop-sidebar"
                  className="ns-filters-toggle"
                >
                  <span class="ns-refine-cat">View all filters</span>
                </label>
                {/* <button class="ns-filters-toggle" onClick={() => { document.querySelector(".ns-sidebar-wrapper").classList.toggle("ns-d-none"); document.querySelector(".ns-sidebar-backdrop").classList.toggle("ns-d-none") } }>View all filters</button> */}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <SelectedFilters />
      <SidebarAside label={"toggle-desktop-sidebar"} />
    </>
  ) : (
    ""
  );
}
